import { CSSProperties, useEffect, useRef, useState } from 'react';
import { ReactComponent as BkgComponent } from '../assets/bkg-intro.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-entrance": "/main",
};

function Home() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [now, setNow] = useState(() => new Date());
  const [overlayStyles, setOverlayStyles] = useState<Record<string, CSSProperties>>({});

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNow(new Date());
    }, 300);

    return () => window.clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const svg = container.querySelector('svg');
    if (!svg) return;

    const targetIds = ['link-date', 'link-time'] as const;

    const syncOverlayPositions = () => {
      const containerRect = container.getBoundingClientRect();
      const nextStyles: Record<string, CSSProperties> = {};

      targetIds.forEach((id) => {
        const target = svg.querySelector<SVGGraphicsElement>(`#${CSS.escape(id)}`);
        if (!target) return;

        const rect = target.getBoundingClientRect();
        nextStyles[id] = {
          left: `${rect.left - containerRect.left}px`,
          top: `${rect.top - containerRect.top}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
        };
      });

      setOverlayStyles(nextStyles);
    };

    syncOverlayPositions();

    const resizeObserver = new ResizeObserver(() => {
      syncOverlayPositions();
    });

    resizeObserver.observe(container);
    resizeObserver.observe(svg);
    window.addEventListener('resize', syncOverlayPositions);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', syncOverlayPositions);
    };
  }, []);

  const dateText = now.toLocaleDateString('sk-SK');
  const timeText = now.toLocaleTimeString('sk-SK', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return <div ref={containerRef} className="page-home-layout">
    <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} containerClassName="page-home-bkg" />
    <div
      className="home-overlay-slot home-date-overlay"
      style={overlayStyles['link-date']}
      aria-live="polite"
    >
      <span className="home-overlay-text">{dateText}</span>
    </div>
    <div
      className="home-overlay-slot home-time-overlay"
      style={overlayStyles['link-time']}
      aria-live="polite"
    >
      <span className="home-overlay-text">{timeText}</span>
    </div>
  </div>
}

export default Home;
